import React from 'react';
import SetInnerHTML from '../../../../../UI/SetInnerHTML/SetInnerHTML';

export class BrandDescription extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      descriptionOpened: this.props.open || false,
    };
  }

  brandDescriptionToggled = (value) => {
    this.setState({ descriptionOpened: value === false ? false : !this.state.descriptionOpened });
  };

  render() {
    if (!(this.props.contentData.aboutBrandEspot && this.props.contentData.brandNameForTitle)) {
      return null;
    }

    return (
      <div className='panel brand-description-wrapper'>
        <button
          type='button'
          onClick={this.brandDescriptionToggled}
          className='panel-title brand-description-title'
          aria-controls={`brand-description-${this.props.contentData.productId}`}
          aria-expanded={this.state.descriptionOpened === true ? 'true' : 'false'}
          ref={this.descButton}
        >
          About {this.props.contentData.brandNameForTitle}
          {this.state.descriptionOpened === true ? (
            <i className='panel-icon expanded'>
              <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48.84 48.84'>
                <title>plus</title>
                <g data-name='Layer 2'>
                  <g data-name='Layer 1'>
                    <path d='M47.84,23.41H25.47V1a1,1,0,0,0-2,0v22.4H1a1,1,0,0,0,0,2H23.45v22.4a1,1,0,1,0,2,0V25.43H47.84a1,1,0,1,0,0-2Z' />
                  </g>
                </g>
              </svg>
            </i>
          ) : (
            <i className='panel-icon'>
              <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48.84 48.84'>
                <title>plus</title>
                <g data-name='Layer 2'>
                  <g data-name='Layer 1'>
                    <path d='M47.84,23.41H25.47V1a1,1,0,0,0-2,0v22.4H1a1,1,0,0,0,0,2H23.45v22.4a1,1,0,1,0,2,0V25.43H47.84a1,1,0,1,0,0-2Z' />
                  </g>
                </g>
              </svg>
            </i>
          )}
        </button>
        <div
          className={`col-sm-12 brand-description ${this.state.descriptionOpened === true ? '' : 'hidden'}`}
          id={`brand-description-${this.props.contentData.productId}`}
        >
          <SetInnerHTML innerHTML={this.props.contentData.aboutBrandEspot} />
        </div>
      </div>
    );
  }
}

export default BrandDescription;
